export const SUBSCRIPTIONS_TRANSLATION_NAMESPACE = 'features/subscriptions';
